import { useRouteMatch } from "react-router-dom";
import { supportWidgetPaths } from "@circle-react/helpers/urlHelpers";

interface PostRouteParams {
  id: string;
}

export const useHelpWidgetRoutes = () => {
  const isSpaceGroupsRoutes = Boolean(
    useRouteMatch(supportWidgetPaths.spaceGroups()),
  );

  const postMatch = useRouteMatch<PostRouteParams>("/posts/:id");
  const newsMatch = useRouteMatch<PostRouteParams>("/news/:id");
  const singleConversationMatch = useRouteMatch<PostRouteParams>({
    path: "/conversations/:id",
    exact: true,
  });

  const isSpaceRoute = Boolean(useRouteMatch("/spaces/:spaceId/posts"));
  const isPostRoute = Boolean(postMatch);
  const isNewsRoute = Boolean(newsMatch);
  const isNewsListRoute = Boolean(useRouteMatch("/news"));
  const isEventsRoute = Boolean(useRouteMatch("/events"));
  const isSendUsMessageRoute = Boolean(
    useRouteMatch("/conversations/:id/new_ticket"),
  );
  const isMessageConfirmationRoute = Boolean(
    useRouteMatch("/message_confirmation/:id"),
  );
  const isConversationListRoute = Boolean(
    useRouteMatch({ path: "/conversations", exact: true }),
  );
  const isSingleConversationRoute = Boolean(singleConversationMatch);

  const isBackButtonVisible =
    isSpaceRoute ||
    isPostRoute ||
    isNewsRoute ||
    isNewsListRoute ||
    isEventsRoute ||
    isSendUsMessageRoute ||
    isMessageConfirmationRoute ||
    isSingleConversationRoute;

  const isExpandButtonVisible =
    isPostRoute ||
    isNewsRoute ||
    isSendUsMessageRoute ||
    isMessageConfirmationRoute ||
    isSingleConversationRoute;

  const isSpecialHeaderVisible = isBackButtonVisible || isSpaceGroupsRoutes;

  const isConversationsRoute =
    isSingleConversationRoute || isConversationListRoute;

  return {
    isSpaceGroupsRoutes,
    isSpaceRoute,
    postMatch,
    newsMatch,
    isPostRoute,
    isNewsRoute,
    isNewsListRoute,
    isEventsRoute,
    isBackButtonVisible,
    isExpandButtonVisible,
    isSpecialHeaderVisible,
    isSendUsMessageRoute,
    isMessageConfirmationRoute,
    isConversationListRoute,
    isSingleConversationRoute,
    isConversationsRoute,
    singleConversationMatch,
  };
};
